import { combineReducers } from 'redux';
import { walletReducer } from './Wallet';

const rootReducer = combineReducers({
  wallet: walletReducer
});

export default rootReducer;